import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import ThankYouScreen from "./screens/ThankYouScreen/ThankYouScreen";
//import HomeScreen from "./screens/HomeScreen/HomeScreen";
import DesktopScreen from "./screens/DesktopScreen/DesktopScreen";
import { useEffect } from "react";
import axios from "axios";
import { MobileScreen } from "./screens/MobileScreen/MobileScreen";
import { setBuildType } from "./utils/constants";

// const screenWidth = window.innerWidth;

// if(screenWidth > 700){
//   const url = new URL(window.location.href);
//   let utm_source = url.searchParams.get("utm_source");
//   let utm_campaign = url.searchParams.get("utm_campaign");
//   let utm_medium = url.searchParams.get("utm_medium");
//   window.location.href = `
//   https://classplusapp.com?utm_source=${utm_source ? utm_source : "direct"}&utm_medium=${utm_medium ? utm_medium : "convo-lp"}&utm_campaign=${utm_campaign ? utm_campaign: "online"}`
// }

const App = () => {
  const isSmallScreen = useMediaQuery({ query: "(max-width: 800px)" });
  useEffect(() => {
    regionAPICall();
    setBuildType();
  }, []);
  async function regionAPICall() {
    try {
      const resp = await axios.get(
        "https://api.classplusapp.com/v3/countryData/ip"
      );
      if (resp.status == 200) {
        const data = resp.data.data.countryCode;
        if (data?.toUpperCase() === "AU") {
          window.location.href = "https://classplusapp.com/au";
        } else if (data?.toUpperCase() === "SG") {
          window.location.href = "https://classplusapp.sg";
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <Router basename="/grow-your-institute">
      <Routes>
        <Route
          path="/"
          element={isSmallScreen ? <MobileScreen /> : <DesktopScreen />}
        />
        <Route exact path="/ThankYou" element={<ThankYouScreen />} />
        <Route
          path="/index.html"
          element={isSmallScreen ? <MobileScreen /> : <DesktopScreen />}
        />
      </Routes>
    </Router>
  );
};

export default App;
